"use strict";

const { default: Swal } = require("sweetalert2");
const config = require('../../../../../config/locales_json/packs/private/oferts/oferts.json');
const language = $('body').data("language");

var AdminOfertsDatatable = function () {
  // Define shared variables
  var table = document.getElementById('kt_datatable_admin_oferts');
  var datatable;

  // Private functions
  var initOfertsTable = function () {
      // Init datatable --- more info on datatables: https://datatables.net/manual/

      datatable = $(table).DataTable({
        info: true,
        order: [[2, "desc"]],
        pageLength: 10,
        lengthChange: false,
        searching: true,
        autoWidth: false, // Desactiva el ajuste automático de ancho
        responsive: true, // Opcional: hace que la tabla sea responsive
        columns: [
          { width: '25%' },
          { width: '10%' },
          { width: '10%' },
          { width: '10%' },
          { width: '10%' },
          { width: '10%' },
          { width: '10%' },
          { width: '15%' }
        ]
      });
  }

  // Search Datatable --- official docs reference: https://datatables.net/reference/api/search()
  var handleSearchDatatable = () => {
      const filterSearch = document.querySelector('[data-kt-oferts-table-filter="search"]');
      filterSearch.addEventListener('keyup', function (e) {
          datatable.search(e.target.value).draw();
      });
  }

  var _copyURL = function() {
    // Copiar el link
    $("#kt_datatable_admin_oferts").on('click', ".ofert_copy_link", function(e) {
      var $temp = $("<input>");
      var $url = $(this).data('url');
      $("body").append($temp);
      $temp.val($url).select();
      document.execCommand("copy");
      $temp.remove();
      const swalFireText = getTranslationValue(config, [language, "on_click_ofert_copy_link_text"], "URL copiada!")
      Swal.fire({icon: 'success', text: swalFireText, showConfirmButton: true });
    });
  }

  var _changeState = function() {
    $('div#changeStateModal').on("click", "#change_state", function(e){
      const disabledText = getTranslationValue(config, [language, "on_click_change_state_text"], "Enviando Información...");
      $(this).addClass("disabled").text(disabledText);
      $("div#changeStateModal").addClass("disabled");
    })
  }

  var _changeOptionState = function() {
    $('div#changeStateModal').on("change", "#ofert_enum_state", function(e){
      var state = $(this).val();
  
      if(state == "closed"){
        const defaultLabelText = 'Estas cerrando esta oferta, cuéntanos, ¿Conseguiste tu candidato a través de ' + ( origin == 1 ? 'Talento Cloud?' : 'FirstJob?')
        const labelText = getTranslationValue(config, [language, "selectQuestion", ( origin == 1 ? 'label_aws' : 'label') ], defaultLabelText);
        
        const defaultOptionText = getTranslationValue(config, [language, "selectQuestion", "default_option"], 'Seleccione una opción');
        const firstOPtionText = getTranslationValue(config, [language, "selectQuestion", "option1"], 'Si');
        const secondOptionText = getTranslationValue(config, [language, "selectQuestion", "option2"], 'No');
  
        var selectQuestion = '<div id="container-ofert-postulant-found" class="form-group fv-plugins-icon-container">\
                                <label>'+labelText+'</label>\
                                <select id="ofert_postulant_found" class="form-control form-control-lg form-control-solid" name="ofert[postulant_found]">\
                                  <option value="">'+defaultOptionText+'</option>\
                                  <option value="true">'+firstOPtionText+'</option>\
                                  <option value="false">'+secondOptionText+'</option>\
                                </select>\
                              </div>';
  
        $(this).parent().parent().append(selectQuestion);
      } else {
        $(this).parent().parent().find("#container-ofert-postulant-found").remove();
      }
    })
  }

  var _delete_ofert = function() {
    // Al hacer click en eliminar una oferta
    $("#kt_datatable_admin_oferts").on("click", ".delete-button", function(e){
      $('#delete_ofert_modal').modal('toggle')

      // Obtiene el id de la oferta
      var ofertId = $(this).attr("data-id")
      // Asigna el id de la oferta en el campo hidden del modal
      $("#delete_ofert_modal #hidden_modal_id").val(ofertId)
      // Se asigna la url correspondiente, si el usuario es admin
      var slug = $(this).attr("data-slug")
      var url = '/admin/clientes/'+slug+'/ofertas/'+ofertId;

      // Se asigna al form la action
      $("#form_modal_delete_ofert").attr("action", url)

      const description = getTranslationValue(config, [language, "if_hasClass_not_delete", "else_description"], "Esta acción no se puede revertir.")

      const btnText = getTranslationValue(config, [language, "if_hasClass_not_delete", "else_btn"], "Eliminar")

      $("#delete_ofert_modal .modal-body .description").text(description)
      $("#delete_ofert_modal .modal-footer #send_modal_delete_ofert_form").text(btnText)
    })

    // Al cerrar el modal limpia la url y el hidden
    $("#delete_ofert_modal .close").on("click", function(e){
      cleanOfertModalFields()
    })

    // Al hacer click en confirmar eliminacion de oferta
    $("#delete_ofert_modal #cancel_modal_delete_ofert_form").on("click", function(e){
      cleanOfertModalFields()
    })

    // Al hacer click en enviar oferta
    $("#delete_ofert_modal #send_modal_delete_ofert_form").on("click", function(e){
      // Valida que el campo hidden tenga información
      var ofertId = $("#delete_ofert_modal #hidden_modal_id").val()
      // Si tiene informacion ejecuta el formulario
      if(ofertId.length > 0) {
        // Se desabilitan las acciones
        // Si se esta archivando una oferta
        if($(this).hasClass("not-delete")){
          // Cambia el texto del boton a Archivando
          const disabledText = getTranslationValue(config, [language, "on_click_delete_modal", "archived_text"], "Archivando...")
          $(this).addClass("disabled").text(disabledText)
        // De lo contrario esta eliminando una oferta
        } else {
          // Cambia el texto del boton a Eliminando
          const disabledText = getTranslationValue(config, [language, "on_click_delete_modal", "archived_text"], "Eliminando...")
          $(this).addClass("disabled").text("Eliminando...")
        }

        $("#delete_ofert_modal #cancel_modal_delete_ofert_form").addClass("disabled")
        $("#delete_ofert_modal #close_delete_ofert_modal").addClass("disabled")
        $("#form_modal_delete_ofert").submit()
      } else {
        // Si no se puede eliminar
        const modaBodytext = getTranslationValue(config, [language, "modaBodytext"], "Hubo un problema y no se pudo eliminar la oferta. Por favor intente más tarde.")
        $(".modal-body").find(".error-modal").remove()
        $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>'+modaBodytext+'</p></div>')
      }
    })

    // Limpia el campo hidden y la url del form
    function cleanOfertModalFields(){
      // Limpia si hay errores
      $(".modal-body").find(".error-modal").remove()
      // Limpia el campo hidden
      $("#delete_ofert_modal #hidden_modal_id").val(null)
      // Se limpia la url correspondiente
      var url = '';
      $("#form_modal_delete_ofert").attr("action", url)
    }
    /*************
    * FIN ELIMINAR OFERTA
    */
  }

  return {
      // Public functions  
      init: function () {
          if (!table) {
              return;
          }

          initOfertsTable();
          handleSearchDatatable();
          _copyURL();
          _changeState();
          _changeOptionState();
          _delete_ofert();
          // Remueve el input de busqueda por defecto
          $(".dt-search").remove();
      }
  }
}();


jQuery(document).ready(function() {
  if($("#kt_datatable_admin_oferts").length > 0){
    AdminOfertsDatatable.init();
  }
});

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}

	return currentTranslation;
}